import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Button, Tooltip } from "antd";
import { doPatch, doDelete } from "../../../API/apis";
import {  PlusOutlined } from "@ant-design/icons";
import { useStateGlobalContext } from "../../../contexts/GlobalContext";
import { CSVLink } from "react-csv";
import { SlRefresh } from "react-icons/sl";
import Notification from "../../../components/Notification/Notification";
import showConfirmModal from "../../../components/ModalConfirm/ModalConfirm";
import TasksModal from "./components/TasksModal";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { getTasksColumn } from "../../../components/TableColumns/TableColumns";
import { taskActions , taskStatusMap} from "../../../utils/Data";
import ViewTask from "./components/ViewTask";
import { DeleteButton, DownloadButton, RefreshButton } from "../../../components/GlobalComponents/GlobalComponents";
import Title from "../../../components/Title/Title";

const Tasks = () => {
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [taskModal, setTaskModal] = useState(false);
  const [viewTask, setViewTask] = useState(null)
  const { providers, profile, tasks, getTasks } = useStateGlobalContext();
  const role = profile && profile?.user_info[0]?.role;


  const handleUpdate = useCallback((record) => {
    if (record.status !== "Completed") {
      setEdit(true);
      setSelectedItem(record);
      setTaskModal(true);
    } else {
      Notification.warning("Cannot edit a completed task.");
    }
  }, []);

  const handleStatus = useCallback(
    async (record, key) => {
      
      const status = taskStatusMap[key] || "To Do";

      try {
        const response = await doPatch(`/tasks/update/${record.id}`, {status});
        if (response.status === 200) {
          Notification.success("Status updated Successfully");
          getTasks(false);
        }
      } catch (error) {
        Notification.error("An error occurred while updating status");
      }
    },
    [getTasks]
  );

  const columns = getTasksColumn({
    providers,
    taskActions,
    handleStatus,
    handleUpdate,
    setViewTask,
  });

  const handleCancel = useCallback(() => {
    setEdit(false);
    setTaskModal(false);
  }, []);


  const handleDelete = useCallback(() => {
    showConfirmModal({
      title: "Confirm Removal",
      icon: null,
      content: "Are you sure you want to Remove All Completed Tasks?",
      okText: "Remove",
      okType: "danger",
      cancelText: "Cancel",
      className: "custom-modal",
      onOk: confirmDelete,
    });
  }, []);

  const confirmDelete = useCallback(async () => {
    try {
      const response = await doDelete("/tasks/delete-old-tasks/");
      if (response.status === 200) {
        Notification.success("All Completed Tasks Deleted Successfully");
        getTasks(false);
      }
    } catch (error) {
      Notification.error("Something went wrong");
    }
  }, []);

  useEffect(() => {
    const fetchTasks = async () => {
      setLoading(true);
      await getTasks(false);
      setLoading(false);
    };
    fetchTasks();
  }, []);

  document.title = "Tasks | American EMR";

  return (
    <div className="mx-auto">
      <div className="flex justify-between items-center mb-4">
        <Title title="Tasks" />
        <div className="flex gap-2">

          <RefreshButton onClick={()=>getTasks(false)}/>

          {((role === "clinic") ||
            role === "manager") && (
            <DeleteButton onClick={handleDelete}/>
          )}
          {tasks && tasks?.length > 0 && (
            <DownloadButton>
              <CSVLink data={tasks} filename={"Tasks.csv"} className="csv-link">
                 Download Report
               </CSVLink>
            </DownloadButton>
          )}
          <Button
            type="primary"
            className="font-bold"
            onClick={() => setTaskModal(true)}
          >
            New Task <PlusOutlined />
          </Button>
        </div>
      </div>

      <CustomTable
        columns={columns}
        dataSource={tasks}
        loading={loading}
        rowKey="tasks_lists"
      />

      <TasksModal
        visible={taskModal}
        onClose={handleCancel}
        edit={edit}
        selectedItem={selectedItem}
        taskActions={taskActions}
      />

      <ViewTask
        open={viewTask?.open}
        onCancel={()=>setViewTask(null)}
        data={viewTask?.detail}
      />
    </div>
  );
};

export default Tasks;
